// Mock data for Vegr - Road Monitoring App

// Major highways and districts in Nagaland
export const nagalandRoads = [
  // NH 29 (Main highway)
  {
    id: 1,
    name: 'NH 29: Dimapur to Kohima',
    type: 'highway',
    status: 'clear',
    lastUpdated: '2025-01-14T10:30:00',
    coordinates: [
      [25.9115, 93.7283], // Dimapur
      [25.6747, 94.1077]  // Kohima
    ],
    reports: []
  },
  {
    id: 2,
    name: 'NH 29: Kohima to Mokokchung',
    type: 'highway',
    status: 'damaged',
    lastUpdated: '2025-01-14T09:15:00',
    coordinates: [
      [25.6747, 94.1077], // Kohima
      [26.3228, 94.5247]  // Mokokchung
    ],
    reports: [
      {
        id: 101,
        roadId: 2,
        location: 'Near Medziphema Junction',
        coordinates: [25.7833, 93.8833],
        status: 'damaged',
        severity: 'medium',
        description: 'Large pothole on left lane, causing traffic slowdown',
        reportedBy: 'Public User',
        timestamp: '2025-01-14T09:15:00',
        photo: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=400&fit=crop',
        verified: false
      }
    ]
  },
  {
    id: 3,
    name: 'NH 2: Dimapur to Wokha',
    type: 'highway',
    status: 'blocked',
    lastUpdated: '2025-01-14T08:00:00',
    coordinates: [
      [25.9115, 93.7283], // Dimapur
      [26.0989, 94.2630]  // Wokha
    ],
    reports: [
      {
        id: 102,
        roadId: 3,
        location: 'Wokha Road, 15km from Dimapur',
        coordinates: [25.9500, 93.8500],
        status: 'blocked',
        severity: 'high',
        description: 'Major landslide blocking both lanes. Road completely impassable.',
        reportedBy: 'Local Authority',
        timestamp: '2025-01-14T08:00:00',
        photo: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=600&h=400&fit=crop',
        verified: true,
        estimatedClearance: '2025-01-15T18:00:00'
      }
    ]
  },
  {
    id: 4,
    name: 'State Highway: Kohima to Zunheboto',
    type: 'state',
    status: 'clear',
    lastUpdated: '2025-01-14T07:30:00',
    coordinates: [
      [25.6747, 94.1077], // Kohima
      [25.9667, 94.5167]  // Zunheboto
    ],
    reports: []
  },
  {
    id: 5,
    name: 'District Road: Mokokchung to Tuensang',
    type: 'district',
    status: 'damaged',
    lastUpdated: '2025-01-14T11:00:00',
    coordinates: [
      [26.3228, 94.5247], // Mokokchung
      [26.2833, 94.8167]  // Tuensang
    ],
    reports: [
      {
        id: 103,
        roadId: 5,
        location: 'Near Changtongya',
        coordinates: [26.3000, 94.6500],
        status: 'damaged',
        severity: 'low',
        description: 'Minor cracks on road surface, passable with caution',
        reportedBy: 'Public User',
        timestamp: '2025-01-14T11:00:00',
        photo: null,
        verified: false
      }
    ]
  },
  {
    id: 6,
    name: 'NH 702: Kohima to Imphal Border',
    type: 'highway',
    status: 'clear',
    lastUpdated: '2025-01-14T06:00:00',
    coordinates: [
      [25.6747, 94.1077],
      [25.5000, 94.0000]
    ],
    reports: []
  }
];

// Recent reports from all roads
export const recentReports = [
  {
    id: 104,
    roadName: 'NH 29: Dimapur to Kohima',
    location: 'Chumukedima',
    coordinates: [25.8500, 93.7800],
    status: 'clear',
    severity: 'info',
    description: 'Road conditions excellent after recent maintenance',
    reportedBy: 'Highway Authority',
    timestamp: '2025-01-14T10:30:00',
    photo: 'https://images.unsplash.com/photo-1533450718592-29d45635f0a9?w=600&h=400&fit=crop',
    verified: true
  },
  {
    id: 105,
    roadName: 'District Road: Kohima to Phek',
    location: 'Pfutsero Turn',
    coordinates: [25.7200, 94.3500],
    status: 'damaged',
    severity: 'medium',
    description: 'Road shoulder collapsed, reduced to single lane traffic',
    reportedBy: 'Public User',
    timestamp: '2025-01-14T09:45:00',
    photo: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=600&h=400&fit=crop',
    verified: false
  },
  {
    id: 106,
    roadName: 'State Highway: Mokokchung to Mon',
    location: 'Near Longkhim',
    coordinates: [26.4500, 94.6000],
    status: 'blocked',
    severity: 'high',
    description: 'Fallen tree blocking road, clearance team on way',
    reportedBy: 'Local Authority',
    timestamp: '2025-01-14T08:20:00',
    photo: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&h=400&fit=crop',
    verified: true,
    estimatedClearance: '2025-01-14T14:00:00'
  }
];

// Road status categories
export const roadStatuses = [
  {
    value: 'clear',
    label: 'Clear',
    color: '#4A7C59', // Green from Eir
    description: 'Road is clear and safe for travel'
  },
  {
    value: 'damaged',
    label: 'Damaged',
    color: '#C68B3C', // Gold/Amber from Saga
    description: 'Road has damage but is passable with caution'
  },
  {
    value: 'blocked',
    label: 'Blocked',
    color: '#DC2626', // Red for danger
    description: 'Road is blocked and impassable'
  }
];

// Severity levels
export const severityLevels = [
  { value: 'info', label: 'Information', color: '#2C4A5E' },
  { value: 'low', label: 'Minor Issue', color: '#C68B3C' },
  { value: 'medium', label: 'Moderate Issue', color: '#F59E0B' },
  { value: 'high', label: 'Severe Issue', color: '#DC2626' }
];

// Districts in Nagaland
export const nagalandDistricts = [
  { name: 'Dimapur', coordinates: [25.9115, 93.7283] },
  { name: 'Kohima', coordinates: [25.6747, 94.1077] },
  { name: 'Mokokchung', coordinates: [26.3228, 94.5247] },
  { name: 'Tuensang', coordinates: [26.2833, 94.8167] },
  { name: 'Wokha', coordinates: [26.0989, 94.2630] },
  { name: 'Zunheboto', coordinates: [25.9667, 94.5167] },
  { name: 'Phek', coordinates: [25.6667, 94.5000] },
  { name: 'Mon', coordinates: [26.7167, 95.0000] },
  { name: 'Kiphire', coordinates: [25.8833, 94.8333] },
  { name: 'Longleng', coordinates: [26.5333, 94.8333] },
  { name: 'Peren', coordinates: [25.5000, 93.7333] }
];

// SMS integration configuration (for future use)
export const smsConfig = {
  enabled: false,
  shortCode: '54321',
  format: 'VEGR <LOCATION> <STATUS> <DESCRIPTION>',
  example: 'VEGR Kohima-Dimapur BLOCKED Landslide near Medziphema',
  instructions: 'SMS format: VEGR [Location] [Status] [Description]'
};